import {useEffect, useState} from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import {Skeleton} from '@mui/material';
import {Stack} from '@mui/material';

am4core.useTheme(am4themes_animated);
am4core.options.autoSetClassName = true;
am4core.options.minPolylineStep = 5;

const ChartTen = ({data, name, className}) => {
    const [showLoader, setShowLoader] = useState(false);

    useEffect(() => {
        // Create chart instance
        let chart = am4core.create(name, am4charts.XYChart);
        chart.defaultState.transitionDuration = 0;
        chart.hiddenState.transitionDuration = 0;

        chart.events.on('ready', () => {
            setShowLoader(false);
        });

        // Add data
        chart.data = data['data'];

        chart.padding(40, 40, 40, 40);

        let categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.dataFields.category = "gov_entity";
        categoryAxis.renderer.minGridDistance = 1;
        categoryAxis.renderer.inversed = true;
        categoryAxis.renderer.grid.template.disabled = true;

        chart.xAxes.push(new am4charts.ValueAxis());

        let series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.categoryY = "gov_entity";
        series.dataFields.valueX = "arrears_change";
        series.columns.template.tooltipText = "{categoryY}: [bold]{valueX}%[/]";
        series.tooltip.dy = -10;
        series.columns.template.strokeOpacity = 0;

        series.events.on("datavalidated", () => {
            series.columns.each((column) => {
                const value = column.dataItem.valueX;
                if (value >= 0) {
                    column.column.cornerRadiusBottomRight = 5;
                    column.column.cornerRadiusTopRight = 5;
                    column.column.cornerRadiusBottomLeft = 0;
                    column.column.cornerRadiusTopLeft = 0;
                } else {
                    column.column.cornerRadiusBottomRight = 0;
                    column.column.cornerRadiusTopRight = 0;
                    column.column.cornerRadiusBottomLeft = 5;
                    column.column.cornerRadiusTopLeft = 5;
                }
            });
        });

        let labelBullet = series.bullets.push(new am4charts.LabelBullet())
        labelBullet.label.text = "{values.valueX.workingValue.formatNumber('#.##')}%";
        labelBullet.label.truncate = false;

        labelBullet.label.adapter.add('dx', (dx, target) => {
            return target.dataItem.valueX >= 0 ? 25 : -20;
        });

        // as by default columns of the same series are of the same color, we add adapter which takes colors from chart.colors color set
        series.columns.template.adapter.add("fill", function (fill, target) {
            const difficultyLevel = target.dataItem.dataContext.difficulty_level;
            if (difficultyLevel) {
                if (difficultyLevel === 'without_financial_problems') {
                    return am4core.color('#41ad49');
                } else if (difficultyLevel === 'with_financial_problems') {
                    return am4core.color('#fff200');
                } else if (difficultyLevel === 'in_financial_difficulty') {
                    return am4core.color('#f47920');
                } else if (difficultyLevel === 'in_serious_financial_difficulty') {
                    return am4core.color('#d2232a');
                }
                return am4core.color('#9c1519');
            }

            return am4core.color('#8a8a8a'); // Default color if no population value
        });

        categoryAxis.sortBySeries = series;

        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.menu.align = 'left';
        chart.exporting.menu.verticalAlign = 'top';

    }, []);

    return (
        <>
            <div id={name} style={{width: showLoader ? '0' : '100%', height: showLoader ? '0' : '1200px'}} className={className}></div>
            {showLoader && (
                <Stack spacing={1}>
                    <Skeleton variant='text'/>
                    <Skeleton variant='rounded' width={'auto'} height={500}/>
                </Stack>
            )}
        </>
    );
};

export default ChartTen;
